export default __webpack_public_path__ + "static/media/Welcome spring.7cd798f6.jpg";